import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppEnums } from '@root/core/enums/app.enums';
import { RoleSEnums } from '@root/core/enums/roles';
import { NotificationsService } from '@services/notifications/notifications.service';

@Injectable({
  providedIn: 'root',
})
export class Utils {
  constructor(private notificationsService: NotificationsService) { }
  /**
    *
    *
    * @param {*} date
    * @return {*}  {string}
    * @description Salidas:
    * @description         1) dd/mm/yyyy
    * @description         2) Fri, 30 Dec 2022 13:20:17 GMT
    * @description         3) 2022-12-30T13:21:26.545Z
    * @description         4) dd-mm-yyyy
    * @description         5) yyyy
    * @description         6) 2023-01-01
    * @description         7) 2023-1-1
    * @description         8) dd-mm-yyyy
    * @description         9) mm-dd-yyyy
    * @description         10) 01 de Marzo de 2023
    * @description   default) dd/mm/yyyy
    * @memberof Utils
    */
  public formatDate(date: any, formato?: number): string {
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    if (!date) {
      // console.error('fecha sin valor =>', date);
      return date;
    }

    let newDate: any;

    switch (formato) {
      case 1:
        newDate = new Date(date).toLocaleDateString(); // formarto dd/mm/yyy
        break;
      case 2:
        newDate = new Date(date).toUTCString(); //Fri, 30 Dec 2022 13:20:17 GMT
        break;
      case 3:
        newDate = new Date(date).toISOString(); // 2022-12-30T13:21:26.545Z
        break;
      case 4:
        newDate = new Date(date).toLocaleDateString(); // formarto dd/mm/yyyy
        newDate = newDate.replaceAll('/', '-'); // formarto dd-mm-yyyy
        break;
      case 5:
        newDate = new Date(date).toLocaleDateString(); // formarto dd/mm/yyyy
        newDate = newDate.split('/')[2]; // yyyy
        break;
      case 6:
        newDate = new Date(date).toLocaleDateString(); // formarto dd/mm/yyyy
        newDate = newDate.split('/'); // yyyy
        newDate =
          newDate[2] +
          `-${newDate[1] <= 9 ? '0' : ''}` +
          newDate[1] +
          `-${newDate[0] <= 9 ? '0' : ''}` +
          newDate[0];
        break;
      case 7:
        newDate = date;
        newDate = newDate.split('/'); // yyyy-MM-dd
        newDate = newDate[2] + `-` + newDate[1] + `-` + newDate[0];
        break;
      case 8: /** Caso para pormato de fecha (dd-mm-yyyy) para la creación, busqueda de importacion por fechas */
        newDate = new Date(date).toLocaleDateString();
        newDate = newDate.split('/');
        newDate =
          newDate[0] +
          `-${newDate[1] <= 9 ? '0' : ''}` +
          newDate[1] +
          `-${newDate[2] <= 9 ? '0' : ''}` +
          newDate[2];
        break;
      case 9: /** Caso para pormato de fecha (dd/mm/yyy) en el Blog de mensajes */
        newDate = new Date(date).toLocaleDateString();
        newDate = newDate.split('/');
        newDate =
          newDate[1] +
          `/${newDate[0] <= 9 ? '0' : ''}` +
          newDate[0] +
          `/${newDate[2] <= 9 ? '0' : ''}` +
          newDate[2]
        break;
      case 10: /** Caso para pormato de fecha (01 de Marzo de 2023) en el Blog de mensajes */
        newDate = new Date(date).toLocaleDateString();
        newDate = newDate.split('/');
        newDate =
          (newDate[0] <= 9 ? '0' : '') + newDate[0] + ` de ${meses[+newDate[1] - 1]}` + ` de ${newDate[2]}`
        break;
      case 11: /** Caso para pormato de fecha (01 de Marzo de 2023) en el Blog de mensajes */
        newDate = new Date(date).toLocaleTimeString()
        break;
      default:
        newDate = new Date(date).toLocaleDateString(); // formarto dd/mm/yyyy
    }
    return newDate;
  }




  errorManager(error: any, orgin?: string) {
    if (error instanceof HttpErrorResponse) {
      this.notificationsService.info({ titulo: error.error.error, mensaje: error.message, textButtonLeft: AppEnums.acpetar, icon: 'stop' })
    } else {
      if (error) {
        if (error.error) {
          this.notificationsService.info({ titulo: error.error, mensaje: error.message, textButtonLeft: AppEnums.acpetar, icon: 'stop' })
        } else if (error.Message) {
          this.notificationsService.info({ titulo: 'error', mensaje: error.message, textButtonLeft: AppEnums.acpetar, icon: 'stop' })
        } else if ((typeof error) == 'string') {
          this.notificationsService.info({ titulo: 'error', mensaje: error, textButtonLeft: AppEnums.acpetar, icon: 'stop' })
        }
      }
    }
  }

  notificacionInfo(message: string) {
    this.notificationsService.info({ titulo: 'Información', mensaje: message, textButtonLeft: AppEnums.acpetar, icon: 'ok' })
  }

  userDummy() { }

  decodeToken(token: string) {
    const base64Url = token?.split('.')[1];
    const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/');

    return JSON.parse(window.atob(base64));
  }

  rolesFormat(rol: string) {
    if (rol === RoleSEnums.ADMIN) {
      rol = 'Administrador';
    } else if (rol === RoleSEnums.MANAGER) {
      rol = 'Gerente';
    } else if (rol === RoleSEnums.TECHNICAL) {
      rol = 'Tecnico';
    } else if (rol === RoleSEnums.CLIENT) {
      rol = 'Cliente';
    } else if (rol === RoleSEnums.GUEST) {
      rol = 'Usuario';
    } else {
      rol = 'Usuario';
    }

    return rol;
  }

}
